import React, { useEffect, useState } from 'react';
import { UTILITY_OFFLINE_PAYMENT_TAB } from '../../Utils/appConstants';
import EletricityBillPayment from './eletricityBillPayment';
import WaterBillPayment from './waterBillPayment';
import GasBillPayment from './gasBillPayment';
import InsuranceBillPayment from './insuranceBillPayment';
import CommonBillPayment from '../bharatBillpayIP/commonBillPayment';
import BBPSIMW from '../bharatBillpayImWallet/commonBillPayment';
import UtilityOfflineReport from '../reports/uitilityReports2/index.js'
import Maintenance from '../Maintenance';
import { reactLocalStorage } from 'reactjs-localstorage';
import 'antd/dist/antd.css';
import { Tabs, Card , } from 'antd';
import { SearchOutlined, HistoryOutlined, CustomerServiceOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;

// Brand colors
const PRIMARY_COLOR = '#C9262C';

function UitilityPaymentOffline(props) {
  const [tabKey, setTabKey] = useState('1');

  useEffect(() => {
    console.log('props.location.tab -----------', props.location.tab);
    if (props.location.tab) {
      setTabKey(props.location.tab);
    }
  }, [props.location.tab]);

  const items = [
    // {
    //   key: '1',
    //   label: (
    //     <div className="tabtext" title="Electricity BBPS-I">
    //       <span>
    //         <img height="35" width="35" src="/images/electricity.svg" alt="Electricity" />
    //       </span>
    //       Electricity BBPS-I
    //     </div>
    //   ),
    //   children: <BBPSIMW category="Electricity" />,
    // },
    // {
    //   key: '2',
    //   label: (
    //     <div className="tabtext" title="Electricity BBPS-II">
    //       <span>
    //         <img height="35" width="35" src="/images/electricity.svg" alt="Electricity" />
    //       </span>
    //       Electricity BBPS-II
    //     </div>
    //   ),
    //   children: <CommonBillPayment category="Electricity" />,
    // },
    {
      key: '1',
      label: (
        <div className="tabtext" title="Electricity Offline">
          <span>
            <img height="35" width="35" src="/images/electricity.svg" alt="Electricity" />
          </span>
          Electricity
        </div>
      ),
      children: <EletricityBillPayment />,
    },
    // {
    //   key: '4',
    //   label: (
    //     <div className="tabtext" title="Water Bill">
    //       <span>
    //         <img src="/images/water.svg" alt="Water" />
    //       </span>
    //       Water
    //     </div>
    //   ),
    //   children: <WaterBillPayment />,
    // },
    // {
    //   key: '5',
    //   label: (
    //     <div className="tabtext" title="GAS Bill">
    //       <span>
    //         <img src="/images/gas.svg" alt="Gas" />
    //       </span>
    //       GAS
    //     </div>
    //   ),
    //   children: <GasBillPayment />,
    // },
    {
      key: '6',
      label: (
        <div className="tabtext" title="LIC Payment">
          <span>
            <img height="35" width="35" src="/images/lic.png" alt="LIC" />
          </span>
          LIC
        </div>
      ),
      children: <InsuranceBillPayment data={props.location} />,
    },


    {
      key: '7',
      label: (
        <div className="tabtext" title="LIC Payment">
          <span>
            <HistoryOutlined style={{ fontSize: '25px' }} />
          </span>
          HISTORY
        </div>
      ),
      children: <UtilityOfflineReport data={props.location} />,
    },
  ];

  const onchangeTab = (index) => {
    reactLocalStorage.set(UTILITY_OFFLINE_PAYMENT_TAB, index, true);
    setTabKey(index);
  };

  const isUnderMaintenance = false;

  // CSS for uniform styling matching FastagBillPayment
  const tabStyles = `
    .utility-full-width .ant-tabs-nav {
      margin-bottom: 24px;
    }
    .utility-full-width .ant-tabs-nav .ant-tabs-tab {
      margin-right: 20px !important;
      padding: 12px 24px !important;
    }
    .utility-full-width .ant-tabs-nav .ant-tabs-tab:last-child {
      margin-right: 0 !important;
    }
    .utility-full-width .ant-tabs-tab .tabtext {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: bold;
    }
    .utility-full-width .ant-tabs-tab .tabtext span {
      display: flex;
      align-items: center;
    }
    .utility-full-width .ant-tabs-tab .tabtext span:last-child {
      font-weight: 600;
    }
    .utility-header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }
    .utility-logo-img {
      cursor: pointer;
      transition: transform 0.3s;
    }
    .utility-logo-img:hover {
      transform: scale(1.05);
    }
    .utility-card {
      border-radius: 0 !important;
      margin: 0 !important;
      box-shadow: none !important;
      border: none !important;
    }
    .utility-card .ant-card-body {
      padding: 20px !important;
    }
  `;

  return (
    <div>
      <style>{tabStyles}</style>
      {isUnderMaintenance ? (
        <Maintenance />
      ) : (
        <div className="content-wrapper pt-2" style={{ padding: 0 }}>
          <div className="content-header my-0 py-0">
            <div className="container-fluid" style={{ paddingLeft: 0, paddingRight: 0 }}>
              {/* Header with title on left and logo on right */}
              <div className="utility-header-container">
                <div>
                  <h1 className="page-title text-blue font-merriweather" style={{ margin: 0 }}>
                     LIC & Bill <span className="text-red">PAY</span>
                  </h1>
                </div>
                {/* <div>
                  <img
                    className='utility-logo-img'
                    src='../images/bharat_connect.png'
                    width="100"
                    alt='Bharat Connect'
                    style={{ cursor: 'pointer' }}
                  />
                </div> */}
              </div>
            </div>
          </div>
          <div className="content" style={{ padding: 0 }}>
            <div className="container-fluid pt-2 pb-5" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div className="row" style={{ margin: 0 }}>
                <div className="col-md-12" style={{ padding: 0 }}>
                  <Card
                    className="utility-card rounded-0"
                    style={{
                      borderRadius: 0,
                      margin: 0,
                      boxShadow: 'none',
                      border: 'none'
                    }}
                    bodyStyle={{ padding: '20px' }}
                  >
                    <Tabs
                      className="recharge-tabs utility-full-width"
                      activeKey={tabKey}
                      defaultActiveKey={tabKey}
                      onChange={onchangeTab}
                      size="large"
                      tabBarGutter={20}
                      style={{ width: '100%' }}
                      items={items}
                    />
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UitilityPaymentOffline;